import { render, staticRenderFns } from "./refund_detail.vue?vue&type=template&id=d00b8c60&scoped=true&"
import script from "./refund_detail.vue?vue&type=script&lang=js&"
export * from "./refund_detail.vue?vue&type=script&lang=js&"
import style0 from "./refund_detail.vue?vue&type=style&index=0&id=d00b8c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00b8c60",
  null
  
)

export default component.exports